import React from 'react';
import { useAuth } from '../../auth/AuthContext';

type AdminDashboardHeaderProps = {
    onCreateWorkOrder: () => void;
    onViewQuotes: () => void;
    onCreateInvoice: () => void;
    showActions?: boolean;
};

function dashboardTitle(name: string | undefined): string {
    const trimmed = typeof name === 'string' ? name.trim() : '';
    if (!trimmed) return 'Your Dashboard';
    const firstName = trimmed.split(/\s+/)[0];
    const suffix = /s$/i.test(firstName) ? "'" : "'s";
    return `${firstName}${suffix} Dashboard`;
}

function AdminDashboardHeader({
    onCreateWorkOrder,
    onViewQuotes,
    onCreateInvoice,
    showActions = true
}: AdminDashboardHeaderProps): React.JSX.Element {
    const { user } = useAuth();

    return (
        <header className="dash-hero">
            <div className="dash-brand">
                <p className="dash-kicker">Admin</p>
                <h1>{dashboardTitle(user?.name)}</h1>
                <p className="dash-sub">
                    Manage your company workspace — jobs, quotes, invoices, and staff access.
                </p>
            </div>
            {showActions && (
                <div className="dash-actions">
                    <button
                        className="dash-btn dash-btn-primary"
                        type="button"
                        onClick={onCreateWorkOrder}
                    >
                        Create Job
                    </button>
                    <button
                        className="dash-btn dash-btn-primary"
                        type="button"
                        onClick={onViewQuotes}
                    >
                        View / New Quote
                    </button>
                    <button
                        className="dash-btn dash-btn-primary"
                        type="button"
                        onClick={onCreateInvoice}
                    >
                        Create Invoice
                    </button>
                    <button className="dash-btn dash-btn-ghost" type="button">
                        Export Report
                    </button>
                </div>
            )}
        </header>
    );
}

export default AdminDashboardHeader;
